var Backbone, SupportExternalDealNotesTemplate, SupportExternalDealNotesView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportExternalDealNotesTemplate = require('../../../external_deal_notes.html.mustache');

SupportExternalDealNotesView = (function(superClass) {
  extend(SupportExternalDealNotesView, superClass);

  function SupportExternalDealNotesView() {
    return SupportExternalDealNotesView.__super__.constructor.apply(this, arguments);
  }

  SupportExternalDealNotesView.prototype.className = 'row external_deal_notes_row notification info';

  SupportExternalDealNotesView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportExternalDealNotesTemplate;
    return this.setExternalDealNote();
  };

  SupportExternalDealNotesView.prototype.render = function() {
    var ref;
    this.formatExternalDealNotes();
    this.sortExternalDealNotes();
    if (((ref = this.externalDealNotes) != null ? ref[0] : void 0) != null) {
      this.externalDealNotes[0].firstNotes = true;
    }
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportExternalDealNotesView.prototype.setExternalDealNote = function() {
    return this.externalDealNotes = Groupon.Support.ContentModel.externalDealNotes;
  };

  SupportExternalDealNotesView.prototype.toHash = function() {
    var ref, ref1, ref2;
    return {
      isExternalDealNotesPresent: this.externalDealNotesPresent(),
      externalDealNotes: this.externalDealNotes,
      businessName: (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0,
      channelCode: Groupon.Support.currentOrder.DEAL_TYPE,
      dealId: (ref2 = Groupon.Support.currentOrder.deal) != null ? ref2.id : void 0,
      country: window.country.name,
      orderId: Groupon.Support.currentOrder.id
    };
  };

  SupportExternalDealNotesView.prototype.externalDealNotesPresent = function() {
    if (this.externalDealNotes != null) {
      return true;
    } else {
      return false;
    }
  };

  SupportExternalDealNotesView.prototype.sortExternalDealNotes = function() {
    var ref;
    return (ref = this.externalDealNotes) != null ? ref.sort(this.sortbyUpdatedDate) : void 0;
  };

  SupportExternalDealNotesView.prototype.sortbyUpdatedDate = function(a, b) {
    a = getMillisecondsOfUTCDateFromISOStringDate(a.updated_at);
    b = getMillisecondsOfUTCDateFromISOStringDate(b.updated_at);
    return b - a;
  };

  SupportExternalDealNotesView.prototype.formatText = function(text) {
    var formatedText, i, len, part, subtexts;
    if (text != null) {
      formatedText = "";
      subtexts = text.split('\n');
      for (i = 0, len = subtexts.length; i < len; i++) {
        part = subtexts[i];
        if ((part != null ? part.length : void 0) > 0) {
          formatedText = "" + formatedText + part + " ";
          if (part !== _.last(subtexts)) {
            formatedText = formatedText + " <br/> ";
          }
        }
      }
      return formatedText;
    } else {
      return text;
    }
  };

  SupportExternalDealNotesView.prototype.formatExternalDealNotes = function() {
    if (this.externalDealNotes != null) {
      return _.each(this.externalDealNotes, (function(_this) {
        return function(extNote) {
          return extNote.note = _this.formatText(extNote.note);
        };
      })(this));
    }
  };

  return SupportExternalDealNotesView;

})(Backbone.View);

module.exports = SupportExternalDealNotesView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9leHRlcm5hbF9kZWFsX25vdGVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL29yZGVyX3JlbGF0ZWQvZXh0ZXJuYWxfZGVhbF9ub3Rlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsSUFBQSx3RUFBQTtFQUFBOzs7QUFBQSxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFDYixnQ0FBQSxHQUFtQyxPQUFBLENBQVEsNENBQVI7O0FBRTdCOzs7Ozs7O3lDQUNKLFNBQUEsR0FBVzs7eUNBRVgsVUFBQSxHQUFZLFNBQUE7SUFDVixJQUFDLENBQUEsU0FBRCxHQUFhO0lBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtXQUNaLElBQUMsQ0FBQSxtQkFBRCxDQUFBO0VBSFU7O3lDQUtaLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUMsQ0FBQSx1QkFBRCxDQUFBO0lBQ0EsSUFBQyxDQUFBLHFCQUFELENBQUE7SUFDQSxJQUFHLGtFQUFIO01BQWdDLElBQUMsQ0FBQSxpQkFBa0IsQ0FBQSxDQUFBLENBQUUsQ0FBQyxVQUF0QixHQUFtQyxLQUFuRTs7V0FDQSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQUpNOzt5Q0FNUixtQkFBQSxHQUFzQixTQUFBO1dBQ3BCLElBQUMsQ0FBQSxpQkFBRCxHQUFxQixPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQztFQUQ5Qjs7eUNBR3RCLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtXQUFBO01BQUEsMEJBQUEsRUFBNEIsSUFBQyxDQUFBLHdCQUFELENBQUEsQ0FBNUI7TUFDQSxpQkFBQSxFQUFtQixJQUFDLENBQUEsaUJBRHBCO01BRUEsWUFBQSxxRkFBb0QsQ0FBRSxzQkFGdEQ7TUFHQSxXQUFBLEVBQWEsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsU0FIMUM7TUFJQSxNQUFBLDJEQUF5QyxDQUFFLFdBSjNDO01BS0EsT0FBQSxFQUFTLE1BQU0sQ0FBQyxPQUFPLENBQUMsSUFMeEI7TUFNQSxPQUFBLEVBQVMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsRUFOdEM7O0VBRE07O3lDQVNSLHdCQUFBLEdBQTBCLFNBQUE7SUFDeEIsSUFBRyw4QkFBSDthQUE0QixLQUE1QjtLQUFBLE1BQUE7YUFBc0MsTUFBdEM7O0VBRHdCOzt5Q0FHMUIscUJBQUEsR0FBdUIsU0FBQTtBQUNyQixRQUFBO3VEQUFrQixDQUFFLElBQXBCLENBQXlCLElBQUMsQ0FBQSxpQkFBMUI7RUFEcUI7O3lDQUd2QixpQkFBQSxHQUFtQixTQUFDLENBQUQsRUFBRyxDQUFIO0lBQ2pCLENBQUEsR0FBSSx5Q0FBQSxDQUEwQyxDQUFDLENBQUMsVUFBNUM7SUFDSixDQUFBLEdBQUkseUNBQUEsQ0FBMEMsQ0FBQyxDQUFDLFVBQTVDO1dBQ0gsQ0FBQSxHQUFFO0VBSGM7O3lDQUtuQixVQUFBLEdBQWEsU0FBQyxJQUFEO0FBQ1gsUUFBQTtJQUFBLElBQUcsWUFBSDtNQUNFLFlBQUEsR0FBZTtNQUNmLFFBQUEsR0FBVyxJQUFJLENBQUMsS0FBTCxDQUFXLElBQVg7QUFDWCxXQUFBLDBDQUFBOztRQUNFLG9CQUFHLElBQUksQ0FBRSxnQkFBTixHQUFlLENBQWxCO1VBQ0UsWUFBQSxHQUFlLEVBQUEsR0FBRyxZQUFILEdBQWtCLElBQWxCLEdBQXVCO1VBQ3RDLElBQTJDLElBQUEsS0FBUSxDQUFDLENBQUMsSUFBRixDQUFPLFFBQVAsQ0FBbkQ7WUFBQSxZQUFBLEdBQWtCLFlBQUQsR0FBYyxVQUEvQjtXQUZGOztBQURGO0FBSUEsYUFBTyxhQVBUO0tBQUEsTUFBQTtBQVNFLGFBQU8sS0FUVDs7RUFEVzs7eUNBWWIsdUJBQUEsR0FBMEIsU0FBQTtJQUN4QixJQUFHLDhCQUFIO2FBQ0UsQ0FBQyxDQUFDLElBQUYsQ0FBUSxJQUFDLENBQUEsaUJBQVQsRUFBNEIsQ0FBQSxTQUFBLEtBQUE7ZUFBQSxTQUFDLE9BQUQ7aUJBQzFCLE9BQU8sQ0FBQyxJQUFSLEdBQWUsS0FBQyxDQUFBLFVBQUQsQ0FBWSxPQUFPLENBQUMsSUFBcEI7UUFEVztNQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBNUIsRUFERjs7RUFEd0I7Ozs7R0FqRGUsUUFBUSxDQUFDOztBQXVEcEQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
